"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobxReactForm = require("../../utils/mobx-react-form");
var _validatorjs = _interopRequireDefault(require("validatorjs"));
var _DVR = _interopRequireDefault(require("mobx-react-form/lib/validators/DVR"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var plugins = {
  dvr: (0, _DVR["default"])(_validatorjs["default"])
};
var fields = [{
  name: 'phoneNumber',
  rules: 'required|string',
  value: '+1'
}, {
  name: 'password',
  rules: 'required|string'
}, {
  name: 'keepSignedIn',
  rules: 'boolean',
  value: true
}];
var options = {
  validateTrimmedValue: true
};
var _default = exports["default"] = function _default() {
  return new _mobxReactForm.Form({
    fields: fields
  }, {
    plugins: plugins,
    options: options
  });
};
//# sourceMappingURL=domain-login-form-phone-password.js.map